var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project.objectID)?_c('api-editor',{attrs:{"api":_vm.api,"projectId":_vm.project.objectID},on:{"save-and-exit":_vm.create}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }